import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  ImageList,
  ImageListItem,
  Typography,
} from '@mui/material';
import { useTheme, Theme } from '@mui/material/styles';
import React, { FC } from 'react';
import { getImage, ImageSize } from '@shared/utils/imageFormat';
import DropZone from '@/components/ui/dropZone';
import { IMedia } from '@/types/media';
import { useMedia } from '@/media';


interface IProps {
  open: boolean;
  onClose: (value?: string) => void;
  conferenceId: string;
}

const useStyles =  (theme: Theme) => ({
  uploadButton: {
    width: '100% !important',
    height: '100% !important',
    borderStyle: 'dashed !important',
  },
  mediaTile: {
    cursor: 'pointer !important',
    '&:hover': {
      opacity: '0.8 !important,'
    },
  },
  image: {
    backgroundColor: `${theme.palette.grey[300]} !important`,
  },
  dropZone: {
    backgroundColor: '#e0e0e0 !important',
    display: 'inline-block !important', 
    '&:hover': {
      backgroundColor: '#d5d5d5 !important',
      
    },
  },
});

export const MediaPicker: FC<IProps> = ({ open, onClose, conferenceId }) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const { media, loadMedia } = useMedia(conferenceId);

  const onUploadComplete = () => loadMedia();

  const handleItemClick = (value: IMedia) => onClose(value.source_id);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      slotProps={{ transition: { onEnter: loadMedia } }}
      onClose={() => onClose()}
    >
      <DialogTitle>Add media file</DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Box mb={2} textAlign="center">
            <DropZone
              acceptedfiletypes="image/jpeg, image/png, image/webp"
              uploadHandler={onUploadComplete}
              buttonText={'Upload Image'}
              uploadurl={`/api/conferences/${conferenceId}/signmediaupload`}
              sx={classes.dropZone}
            />
            <br />
            <Typography variant="caption">
              Upload an image file or pick one from your media library
            </Typography>
          </Box>
          <ImageList rowHeight={128} cols={4} gap={8}>
            {!!media &&
              media.map((item: IMedia) => (
                <ImageListItem
                  sx={classes.mediaTile}
                  key={item.id}
                  onClick={() => handleItemClick(item)}
                >
                  <img
                    style={classes.image}
                    src={getImage(
                      item.source_id,
                      ImageSize.Medium,
                      conferenceId
                    )}
                  />
                </ImageListItem>
              ))}
          </ImageList>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
